import { render, staticRenderFns } from "./AuthTokensTableAdmin.vue?vue&type=template&id=1a2872be&scoped=true"
import script from "./AuthTokensTableAdmin.vue?vue&type=script&lang=js"
export * from "./AuthTokensTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2872be",
  null
  
)

export default component.exports